module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray@2x-1d5b7f03e13e7cdde0219ca326ff8d8b.png";